import React from 'react';
import {useSearchParams} from 'react-router-dom';
import {ACCEPTED_MESSAGE_FILE_TYPES} from '@/config/conversationAttachments';
import ChatInput from '@/components/chat-input';
import type {ChatInputAttachmentsConfig} from '@/components/chat-input';
import type {PendingAttachment} from '@/hooks/use-message-attachments/useMessageAttachments';

type AttachmentProps = {
  pending: PendingAttachment[];
  isUploading: boolean;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveAttachment: (sourceId: string) => void;
};

interface CommentInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  disabled?: boolean;
  isSubmitting?: boolean;
  placeholder?: string;
  attachments?: AttachmentProps;
}

function CommentInput({
  value,
  onChange,
  onSubmit,
  disabled,
  isSubmitting,
  placeholder,
  attachments,
}: CommentInputProps) {
  const [searchParams] = useSearchParams();
  const autoFocus = searchParams.get('autoFocusComment') === 'true';
  const chatInputAttachments: ChatInputAttachmentsConfig | undefined =
    attachments
      ? {
          ...attachments,
          accept: ACCEPTED_MESSAGE_FILE_TYPES.join(','),
        }
      : undefined;

  return (
    <ChatInput
      value={value}
      onChange={onChange}
      onSubmit={onSubmit}
      disabled={disabled}
      isSubmitting={isSubmitting}
      placeholder={placeholder}
      showEmoji
      attachments={chatInputAttachments}
      autoFocus={autoFocus}
    />
  );
}

export default CommentInput;
